import { render } from "./showReceipt.vue?vue&type=template&id=5d1471b0"
import script from "./showReceipt.vue?vue&type=script&lang=js"
export * from "./showReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__